// models component
import Folder from '@/models/Folder'

export default class FolderFetchByShare {
    static of() {
        return Promise.resolve()
            .then(function () {
                return Folder.api()
                    .fetchByShare()
                    .then(function (result) {
                        return result
                    })
            })
            .catch(() => {
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
